// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
    color: #009966 !important;
}
a:hover {
    color: #009966 !important;
}

.btn-primary {
    display: flex;
    /* flex-direction: row; */
    align-items: center;
    padding: 13px 10px;
    /* gap: 8px; */
    /* position: absolute; */
    /* width: 114px; */
    height: 40px;
    /* left: 288px; */
    /* top: 661px; */
    background: var(--primary-color);
    border-radius: 5px;
    font-weight: 600;
}
.btn-primary:hover {
    display: flex;
    /* flex-direction: row; */
    align-items: center !important;
    padding: 13px 10px;
    /* gap: 8px; */
    /* position: absolute; */
    /* width: 114px; */
    height: 40px;
    background: var(--primary-color) !important;
    border-radius: 5px;
    font-weight: 600;
}
.back-button {
    width: auto;
    height: 40px;
    display: flex;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.03em;

    color: #808080;
    align-items: center;
    background: #F0F2F5;
}
.back-button:hover {
    width: auto;
    height: 40px;
    display: flex;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.03em;

    color: #808080 !important;
    align-items: center;
    background: #F0F2F5;
    border-color: #F0F2F5 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/buttonStyles.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,wBAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,wBAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;;IAEtB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;;IAEtB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;AACpC","sourcesContent":["a {\n    color: #009966 !important;\n}\na:hover {\n    color: #009966 !important;\n}\n\n.btn-primary {\n    display: flex;\n    /* flex-direction: row; */\n    align-items: center;\n    padding: 13px 10px;\n    /* gap: 8px; */\n    /* position: absolute; */\n    /* width: 114px; */\n    height: 40px;\n    /* left: 288px; */\n    /* top: 661px; */\n    background: var(--primary-color);\n    border-radius: 5px;\n    font-weight: 600;\n}\n.btn-primary:hover {\n    display: flex;\n    /* flex-direction: row; */\n    align-items: center !important;\n    padding: 13px 10px;\n    /* gap: 8px; */\n    /* position: absolute; */\n    /* width: 114px; */\n    height: 40px;\n    background: var(--primary-color) !important;\n    border-radius: 5px;\n    font-weight: 600;\n}\n.back-button {\n    width: auto;\n    height: 40px;\n    display: flex;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 19px;\n    letter-spacing: 0.03em;\n\n    color: #808080;\n    align-items: center;\n    background: #F0F2F5;\n}\n.back-button:hover {\n    width: auto;\n    height: 40px;\n    display: flex;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 19px;\n    letter-spacing: 0.03em;\n\n    color: #808080 !important;\n    align-items: center;\n    background: #F0F2F5;\n    border-color: #F0F2F5 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
